export const TAGS_KEYS = {
  category: "Category",
  tag: "Tag",
  status: "Status",
  phase: "Phase",
  icon: "Icon"
};
